export const RiskLevelScoreEnum = {
  ZERO: 0,
  LOW: 50,
  MEDIUM: 100,
  HIGH: 1000
}

export const DetectionRiskLevelScoreEnum = {
  ZERO: 0,
  LOW: 1,
  MEDIUM: 5,
  HIGH: 10
}

export const RiskLevelEnum = {
  ZERO: 'zero',
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high',
  properties: {
    zero: {
      title: 'Zero',
      state: 'ZERO',
      color: 'rgb(255, 255, 255)'
    },
    low: {
      title: 'Low',
      state: 'LOW',
      color: 'rgb(254, 229, 234)'
    },
    medium: {
      title: 'Medium',
      state: 'MEDIUM',
      color: 'rgb(250, 146, 168)'
    },
    high: {
      title: 'High',
      state: 'HIGH',
      color: 'rgb(222, 46, 82)'
    }
  }
}



// WEBPACK FOOTER //
// ./src/constants/risk-level.constants.js